import { render, staticRenderFns } from "./DictList.vue?vue&type=template&id=457049d1&scoped=true"
import script from "./DictList.vue?vue&type=script&lang=js"
export * from "./DictList.vue?vue&type=script&lang=js"
import style0 from "./DictList.vue?vue&type=style&index=0&id=457049d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457049d1",
  null
  
)

export default component.exports